import { Modal as MuiModal } from "@mui/material";
import { ModalProps } from "@mui/material/Modal";

export type Props = ModalProps;

export const Modal: React.FC<Props> = (props) => {
  return <MuiModal {...props} />;
};
